<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Inventory Labeled - Form 
        <div class="card-header-actions">
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="7" class="pr-5">
                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Inventory Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" ></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">      
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.asdatacq" type="date" :state="!$v.model.asdatacq.$error" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-input-group >
                    <b-input-group-prepend><label>Inventory Name</label></b-input-group-prepend>
                    <b-form-input v-model="model.asdesc" :state="!$v.model.asdesc.$error"></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Brand/Merk</label></b-input-group-prepend>
                        <b-form-input v-model="model.brand" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                        <b-form-input v-model="model.vendorinfo" placeholder="Vendor Code | Vendor Name"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Other Information</label></b-input-group-prepend>
                        <b-form-input v-model="model.otherinfo" placeholder="e.g Nomor Polisi, Computer Card, Unique Code"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">    
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorpo" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col class="pr-4" lg="5">
                    <b-input-group >
                        <b-input-group-prepend><label>User of Asset</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                        <b-input-group-append>
                            <b-btn text="Button" @click="clearCrew" class="ml-1"> Clear</b-btn>
                        </b-input-group-append>
                      <b-form-checkbox  class="mt-2 ml-1" v-model="model.aspublic" @change="clearDepartment" :value=1 unchecked-value=0 >Available (Not Used)</b-form-checkbox>
                    </b-input-group>
                <b-input-group >
                  <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.userdepartname" ></b-form-input>
                    <b-input-group-append>
                        <b-btn text="Button" @click="lkuDepartmentShow=true" ><i class="fa fa-search"></i></b-btn>
                    </b-input-group-append>
                        <b-form-input v-model="model.asuser" placeholder="usage remark" class="ml-1"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Location of Asset</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.lokasiinfo"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuLocationShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                    <b-form-input v-model="model.aslocat" placeholder="location remark" class="ml-1"></b-form-input>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Last Opname/Audit</label></b-input-group-prepend>
                        <b-form-input v-model="model.opnamelastd" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Status</span></b-input-group-prepend>
                        <b-form-input v-model="model.opnamestatus"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Managed by Dept.</label></b-input-group-prepend>
                        <b-form-input v-model="model.departmenpic" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row> -->
                <b-row class="justify-content-center mt-1 mb-1">
                    <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                    <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </b-row>

          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuDepartmentShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDepartment"></lku-department>
        </b-modal>     
        <b-modal v-model="lkuLocationShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-location @click="onSelectLkuLocation"></lku-location>
        </b-modal>        

        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<style lang="scss">
    .table-wraper {
         width:100%;
         height:380px;
         overflow-x: auto;
         overflow-y: auto;
        border: 1px solid silver;
    }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import myNumber from "../../components/my-number";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuDepartment from "../lookup/lkuDepartment";
import lkuLocation from "../lookup/lkuAssetlocat";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import fixedasset from '../../apis/inventorylabeled';
toastr.init();

export default {
  components: { Loading, myNumber, lkuCrew,lkuDepartment, lkuLocation},
  mixins: [validationMixin],
  validations: {
    model: {
        asdesc: { required },
        asdatacq: { required },
    },
    childObj: {
        asetkey: { required },
        childAsetName: { required },
    },

  },   
  data() {
    return {
      isLoading:false,
      saveEnabled: true,
      showForm: false,
      lkuCrewShow:false,
      lkuCrewData:{},
      lkuDepartmentShow:false,
      lkuItemShow:false,
      lkuLocationShow:false,
      model:{asdesc:'', aspublic:0},
    }
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidChild() {
      this.$v.childObj.$touch();
      return this.$v.childObj.$invalid;
    },
  },
  created: async function (){
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;
      if (this.$route.params.asetkey)  {
          toastr.info('Loading Inventory Detail, please wait')
          try {
            const data = await fixedasset.detailga(this.$route.params);  
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.aspublic = this.model.aspublic || 0;
            this.model.asdatacq = row.asdatacq ? moment(row.asdatacq).format('YYYY-MM-DD') : '';
            // this.model.asdatuse = row.asdatuse ? moment(row.asdatuse).format('YYYY-MM-DD') : '';
            this.model.tglgaransi = row.tglgaransi ? moment(row.tglgaransi).format('YYYY-MM-DD') : '';
            // this.model.tglAkhirDepr = row.tglAkhirDepr ? moment(row.tglAkhirDepr).format('YYYY-MM-DD') : '';
            // this.amortzHist.items = data[1];
            this.model.opnamelastd = row.opnamelastd ? moment(row.opnamelastd).format('YYYY-MM-DD') : '';
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    onSelectLkuItem(_selected) {
        this.childObj.iteminfo = _selected.partnumber.trim() + ' | ' + _selected.itemname.trim();
        this.childObj.partnumber = _selected.partnumber;
        this.childObj.itemno = _selected.itemno;
        this.childObj.itemname = _selected.itemname;
        this.childObj.childAsetName = this.childObj.childAsetName || _selected.itemname;
        this.lkuItemShow=false;
    },
    onSelectLkuCrew:  function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewnik = lkuData.selected.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        // this.model.departemen = lkuData.selected.departemen;
        this.model.userdepartname = lkuData.selected.departemen.trim();
        this.model.userdepartid = lkuData.selected.departid;
        this.model.aspublic=0;
    },
    onSelectLkuDepartment:  function (_selected) {
        this.model.userdepartname = _selected.departemen.trim();
        this.model.userdepartid = _selected.departid;
        this.model.userdepartkd = _selected.departkd;
        this.model.aspublic=0;
        this.lkuDepartmentShow=false;
    },
    onSelectLkuLocation:function (_selected) {
        this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.tblData.aslocat = _selected.namalokasi.trim();
        this.model.aslocatkey = _selected.aslocatkey;
        this.model.kodelokasi = this.model.kodelokasi;
        this.model.namalokasi = _selected.namalokasi;
        this.lkuLocationShow=false;
    },
    clearCrew: function() {
        this.model.crewinfo = '';
        this.model.crewkey = '';
        this.model.crewnik = '';
        this.model.jabatan = '';
    },
    clearDepartment: function() {
        this.model.userdepartname = '';
        this.model.userdepartid ='';
        this.model.userdepartkd = '';
    },
    save: async function () {
        // console.log('Save Clicked');
        // if (!this.saveEnabled) {
        //     toastr.error('View mode cannot be Saved');
        //     return;
        // }
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.isLoading=true;
              let data= {}
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              // data.asdatacq = moment(this.model.asdatacq).format('YYYY-MM-DD');
              // data.asdatuse = (this.model.asdatuse) ? moment(this.model.asdatuse).format('YYYY-MM-DD') : '';
              data.tglgaransi = (this.model.tglgaransi) ? moment(this.model.tglgaransi).format('YYYY-MM-DD') : '';
              data.opnamelastd = (this.model.opnamelastd) ? moment(this.model.opnamelastd).format('YYYY-MM-DD')  : '';

              const hasil = await fixedasset.save(data);
              toastr.success(`Save Success, ${hasil.asetid}`, "Inventory",10000);
              this.isLoading=false;
              this.close();
            } catch (error) {
              this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'fixedasset.invlabelfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'fixedasset.home'});
      }
    },    
  }
};
</script>
